<div>
  <span class="flex">
    <label class="col text-left strong no-margin pb-0" for="input-name_{{catalog.id}}_{{turn}}">{{catalog.name}}</label>
  </span>

  <div class="flex">
    <span class="col">
      <textarea pInputTextarea name="input-name_{{catalog.id}}_{{turn}}" [(ngModel)]="catalog.details" [rows]="2"
        validation [required]="catalog.stomatognathic != null && !readonly" [readonly]="readonly" class="uppercase"
        (ngModelChange)="handleChange()">
      </textarea>
    </span>
  </div>
</div>